


























































import { defineComponent, computed, Ref, ref, onMounted, onUnmounted, ComputedRef, watch} from "@vue/composition-api";

// components
import BaseAvatar from '@/components/NEW-STRUCTURE/desktop/Admin/components/BaseAvatar.vue';

// types
import { ChannelMember } from '@/views/Admin/Channels/channelTypes';


export default defineComponent({
    components: {
        BaseAvatar,
    },
    props: {
        channelMember: ChannelMember,
        isActive: Boolean,
    },
    setup(props, { emit, root }) {

        const activeMemberActions = ref(false);
        const showRemoveOptions = ref(false);
        const memberHasBeenRemoved = ref(false);

        function handleMemberActions() {
            if (!activeMemberActions.value) {
                emit('memberOptionsActive', props.channelMember);
            } else {
                emit('memberOptionsDeactive');
            }
            activeMemberActions.value = !activeMemberActions.value;            
        }

        const viewMemberProfile = () => {
            if (props.channelMember instanceof ChannelMember) {
                emit('viewMemberProfile', props.channelMember);
                handleMemberActions();
            }
        };

        // TODO remove member from channel
        const removeMember = () => {
            if (props.channelMember instanceof ChannelMember) {
                console.log('handleRemoveMember');
                memberHasBeenRemoved.value = true;
                showRemoveOptions.value = false;
            }
        };

        const removeMemberFromMemberList = () => {
            emit('memberHasBeenRemoved', props.channelMember);
            memberHasBeenRemoved.value = false;
        };

        const handleRemoveMember = () => {
            showRemoveOptions.value = true;
            handleMemberActions();
        };

        const handleCancel = () => {
            showRemoveOptions.value = false;
        };

        onUnmounted(() => {
            activeMemberActions.value = false;
            showRemoveOptions.value = false;
            memberHasBeenRemoved.value = false;
        });
        
        return {
            activeMemberActions,
            handleRemoveMember,
            handleCancel,
            handleMemberActions,
            memberHasBeenRemoved,
            removeMember,
            removeMemberFromMemberList,
            showRemoveOptions,
            viewMemberProfile,
        };
    }
});
